import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import DepartmentImage from '../../../assets/image/department/elderly-indian-man-self-isolation-home.jpg';
import DepartmentImage2 from '../../../assets/image/department/volunteers-helping-elderly-people-illustrated_52683-38805.jpg';

function SeniorServices() {

  const [Faq, setFaq] = useState(0);

  const Drop = [
    {
      Que: "What resources are available for senior citizens?",
      Answer: "The Department of Senior Services offers meal delivery, social activities, and assistance with healthcare access."
    },
    {
      Que: "How can I enroll in senior community programs?",
      Answer: "Enrollment can be completed online or by visiting our local Senior Services centers."
    },
    {
      Que: "What transportation services are available for seniors?",
      Answer: "We provide accessible transportation options for medical appointments and social activities."
    }
  ];

  return (
    <>
      <section className="department-details-section">
        <div className="container">
          <div className="row">

            {/* Sidebar */}
            <div className="col-12 col-lg-4 col-xl-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-8">
              <div className="department-details-imgbox">
                <img src={DepartmentImage} className="img-fluid" alt="Senior Services" />
              </div>

              <div className="department-details-content-box">
                <h4 className="department-details-title">Senior Services</h4>
                <p>
                  The Department of Senior Services is dedicated to enhancing the quality of life for senior citizens through comprehensive programs and resources. 
                  Our mission is to ensure seniors have access to the care, support, and opportunities they need to lead active and fulfilling lives.
                </p>
              </div>

              <div className="department-details-box">
                <div className="department-details-policy">
                  <span>
                    Supporting seniors with care, dignity, and respect.
                  </span>
                </div>
                <p>
                  Our department focuses on promoting independence and well-being for senior citizens by offering tailored services and fostering community engagement.
                </p>
              </div>

              <div className="department-details-benefits-inner-box">
                <div className="row row-gutter-30">
                  <div className="col-lg-6">
                    <div className="department-details-benefits-box-image">
                      <img src={DepartmentImage2} className="img-fluid" alt="Senior Community Programs" />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="department-details-benefits-box">
                      <h3>Our Benefits</h3>
                      <p>
                        Enhancing the lives of seniors through dedicated programs and services.
                      </p>
                      <ul className="list-unstyled list-style">
                        <li>
                          <Link to="/department/senior-services/health-wellness">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Senior Health and Wellness Programs
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/senior-services/social-activities">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Social and Recreational Activities for Seniors
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/senior-services/elder-care">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Elder Care Support and Resources
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/senior-services/housing">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Senior Housing and Independent Living Assistance
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordian-box">
                {Drop.map((items, index) => (
                  <div className={`accordian-box-item ${Faq !== index && "active"}`} key={index}>
                    <div className="accordian-title">
                      <h5>{items.Que}</h5>
                      <i className="fa-solid fa-angle-right" onClick={() => setFaq(index)} />
                    </div>

                    {Faq === index && (
                      <div className="accordian-content" style={{ display: "block" }}>
                        <p>{items.Answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SeniorServices;
